$(document).ready(function(){
		
		
		$(function(){$(window).scroll(function(){
						$(".scroll_ani").each(function(){var n=$(this).offset().top,e=$(window).scrollTop(),o=$(window).height();e>n-o+-100&&$(this).	addClass("active")
						})
				})
		}),
		
		
		
		$(function() {
				$(".menu a").click(function(){
						$(".sub_grand_menu_top .button-navi-icon").addClass("close");
						$(".btn_close").css('z-index', '9999');
						$("html, body").css('overflow', 'hidden');
						$("#main_menu").fadeIn();
				});
		});
		
		
		
		
		$(function() {
				$(".btn_close").click(function(){
						$(".sub_grand_menu_top .button-navi-icon").removeClass("close");
						$(".btn_close").css('z-index', '-9999');
						$("html, body").css('overflow', 'visible');
						$("#main_menu").fadeOut();
				});
		});
		
		$(function() {
				$(".g_menu a").click(function(){
						$(".sub_grand_menu_top .button-navi-icon").removeClass("close");
						$(".btn_close").css('z-index', '-9999');
						$("html, body").css('overflow', 'visible');
						$("#main_menu").fadeOut();
				});
		});
		
		
		
		
		$(window).on('scroll',function(){
				var winPosTop = $(window).scrollTop();
				if(winPosTop >= 300){
					$('body').addClass("active");
				} else if(winPosTop < 300){
					$('body').removeClass("active");
				}
		});
		
		
		
		$('.ancher').click(function(){
				var target = $(this.hash);
				//$(this).text(target.length+"/");
				if (target) {
					var targetOffset = target.offset().top;
					$('html,body').animate({scrollTop: targetOffset},1400,"easeInOutQuint");
				return false;}
		});
		
		
		
		
document.addEventListener('scroll', function() {
  const hwSections = document.querySelectorAll('.h_w');
  if (!hwSections.length) return;

  const center = window.scrollY + window.innerHeight / 2;
  let isInside = false;

  hwSections.forEach(hw => {
    const top = hw.offsetTop;
    const bottom = top + hw.offsetHeight;

    if (center >= top && center <= bottom) {
      isInside = true;
    }
  });

  if (isInside) {
    document.body.classList.add('w_ver');
  } else {
    document.body.classList.remove('w_ver');
  }
});

		
		
		
		
		
		
	});
















